import { useQuery } from "@tanstack/react-query";
import { useContainer } from "@src/contexts/container-context";

/**
 * Hook to fetch a provider icon
 */
export function useProviderIcon(providerId, options = {}) {
  const { integrationService } = useContainer();

  return useQuery({
    queryKey: ["providerIcon", providerId],
    queryFn: () => integrationService.getProviderIconRect(providerId),
    enabled: !!providerId && options.enabled !== false,
    ...options,
  });
}

/**
 * Hook to fetch multiple provider icons
 */
export function useProviderIcons(providerIds, options = {}) {
  const { integrationService } = useContainer();
  const uniqueIds = [...new Set(providerIds)].filter(Boolean);

  return useQuery({
    queryKey: ["providerIcons", uniqueIds.sort().join(",")],
    queryFn: async () => {
      const icons = {};
      await Promise.all(
        uniqueIds.map(async (id) => {
          try {
            const icon = await integrationService.getProviderIconRect(id);
            icons[id] = icon;
          } catch (error) {
            console.error(`Failed to load icon for provider ${id}:`, error);
          }
        })
      );
      return icons;
    },
    enabled: uniqueIds.length > 0 && options.enabled !== false,
    ...options,
  });
}
